import $ from 'jquery'
import {win} from "./main";

export default  function isOnScreen(element) {
    let viewport: any = {
        top: win.scrollTop(),
        left: win.scrollLeft(),
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    const elementOffset: any = $(element).offset();
    if (typeof elementOffset === 'undefined') return;
    elementOffset.right = elementOffset.left + $(element).outerWidth();
    elementOffset.bottom = elementOffset.top + $(element).outerHeight();
    const isVisible = (!(viewport.right < elementOffset.left || viewport.left > elementOffset.right || viewport.bottom < elementOffset.top || viewport.top > elementOffset.bottom));
    if (isVisible) {
        return viewport.top >= elementOffset.top - 70;
    } else {
        return isVisible;
    }
}
